/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Min_AvailableInputs */

const en_cargos_min_available = /** @type {(inputs: Cargos_Min_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min available`)
};

const es_cargos_min_available = /** @type {(inputs: Cargos_Min_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min disponible`)
};

/**
* | output |
* | --- |
* | "Min available" |
*
* @param {Cargos_Min_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_min_available = /** @type {((inputs?: Cargos_Min_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Min_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_min_available(inputs)
	return es_cargos_min_available(inputs)
});